import { Flex } from '@chakra-ui/react';
import { ReceiptLong } from '@mui/icons-material';
import ListingCard from 'components/listing/ListingCard';
import PaginateControls from 'components/listing/PaginateControls';
import { displayNumericString, formatDataType, getImage } from 'utils/format';

export default function History({
	paginatedData,
	cardBg,
	iconBg,
	totalPages,
	currentPage,
	setCurrentPage,
}) {
	const getCardProps = (tx) => {
		return {
			imageSrc: getImage(tx._brandId?.image, 'logo'),
			iconComponent: ReceiptLong,
			title: `${tx._brandId?.brandName || ''}${tx.id ? ` #${tx.id}` : ''}`,
			subtitle: formatDataType('date', tx.createdAt),
			borderColor: `${tx.status === 'activo' ? 'green' : 'yellow'}.400`,
			badge: {
				label: formatDataType('status', tx.status || 'PENDIENTE'),
				colorScheme: tx.status === 'activo' ? 'green' : 'yellow',
			},
			details: [
				{
					label: 'Monto',
					value: `${displayNumericString(tx.amount)} ${tx.currency || 'MXN'}`,
				},
				{
					label: 'Orden',
					value: tx.order,
				},
				{
					label: 'Fecha de compra',
					value: formatDataType('date_wo_time', tx.buyDate),
				},
			],
		};
	};
	return (
		<>
			<Flex
				direction='column'
				overflowY='auto'
				maxH='60vh'
				minH='60vh'
				gap={5}
				px={6}
			>
				{paginatedData.map((tx) => {
					return (
						<ListingCard
							key={tx.id}
							idx={tx.id}
							iconBg={iconBg}
							cardBg={cardBg}
							{...getCardProps(tx)}
						/>
					);
				})}
			</Flex>
			<PaginateControls
				setCurrentPage={setCurrentPage}
				currentPage={currentPage}
				totalPages={totalPages}
			/>
		</>
	);
}
